import React from 'react';
import { Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-neutral-900 dark:bg-neutral-950 text-neutral-100 dark:text-neutral-300 py-8 border-t border-neutral-200 dark:border-neutral-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-center md:text-left">
            <p className="text-neutral-400 dark:text-neutral-500 text-sm">
              © {currentYear} Mohammad Cordova. All rights reserved.
            </p>
          </div>

          <div className="flex items-center gap-2 text-neutral-400 dark:text-neutral-500 text-sm">
            <span>Built with</span>
            <Heart className="w-4 h-4 text-red-500 fill-current" />
            <span>using React & Node.js</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
